import * as z from "zod";
import { isEffortLevel, isManagedChatModel } from "../aiProviders";
import { userFacingError } from "../authorization";
import { mutator } from "./mutator";

// The tenant admin's default chat model and effort for the environment-managed
// AI provider (which has no ai_providers row). Null clears a field back to the
// hardcoded managed default. The fast model is derived from the chat model's
// family, not stored. Models are validated against the static catalog, not
// regional availability — resolution falls back if one later becomes unavailable.
export const setManagedAIProviderConfig = mutator({
  schema: z.object({
    chatModel: z.string().nullable(),
    effort: z.string().nullable(),
  }),
  resolve: {},
  permissions: [
    {
      permission: "tenant:ai_providers_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, ctx, args }) => {
    if (args.chatModel != null && !isManagedChatModel(args.chatModel)) {
      throw userFacingError(`Unknown managed model: ${args.chatModel}`);
    }
    if (args.effort != null && !isEffortLevel(args.effort)) {
      throw userFacingError(`Unknown effort level: ${args.effort}`);
    }
    await tx.mutate.tenants.update({
      id: ctx.tenantId,
      managedAiChatModel: args.chatModel,
      managedAiEffort: args.effort,
      updatedAt: Date.now(),
    });
  },
});
